const t=t=>{if(!t||!t.style)return;const e=t.style.split(";");return e.find((t=>t.includes("text-align")))?.replace("text-align: ","")};export{t as getTextAlign};
//# sourceMappingURL=getTextAlign.js.map
